export const getRootBrand = (brandId?: string) => (brandId ? (/./g.test(brandId) ? brandId.split("/")[0] : brandId) : null);
